import React from 'react';
import PropTypes from 'prop-types';

import { ListingTable } from 'components/listing';
import { StatusBadge } from 'components/status';
import { Numeric } from 'components/formatting';
import { Button } from 'components/buttons';
import { Modal, ModalSize } from 'components/notifications';
import { parseBytesTo } from 'utils/parseBytesTo';

const defaultArray = [];

const noValue = "-";

const partNumberColumnWidth = 80;
const partStatusColumnWidth = 200;
const partFilesColumnWidth = 120;
const partSizeColumnWidth = 120;
const partActionsColumnWidth = 140;

const partHeaders = ["Part", "Status", "Files", "Size", ""];
const partColumnWidths = [
    partNumberColumnWidth,
    partStatusColumnWidth,
    partFilesColumnWidth,
    partSizeColumnWidth,
    partActionsColumnWidth
];

// A large extract is split across several zips, each of which can be taken on its own.
export function FileExtractPartsModal(
    {
        showModal = false,
        title = "",
        parts = defaultArray,
        downloadingPartIds = defaultArray,
        canDownloadPart,
        getStatusDisplay,
        onDownloadPart,
        onCloseModal
    }
) {

    const partRows = parts.map((part) => {
        const statusDisplay = getStatusDisplay(part.status);

        return [
            <div key={`file-extract-modal-part-${part.id}-number`}>{part.partNumber}</div>,
            <StatusBadge
                key={`file-extract-modal-part-${part.id}-status`}
                text={statusDisplay.label}
                iconName={statusDisplay.iconName}
                intent={statusDisplay.intent}
                animated={statusDisplay.animated}
            />,
            <Numeric key={`file-extract-modal-part-${part.id}-files`}>{part.fileCount}</Numeric>,
            <div key={`file-extract-modal-part-${part.id}-size`}>
                {part.zipSizeBytes == null ? noValue : parseBytesTo(part.zipSizeBytes).auto()}
            </div>,
            <div className="button-row-small" key={`file-extract-modal-part-${part.id}-download`}>
                <Button
                    id={`file-extract-part-download-${part.id}`}
                    icon="download"
                    text="Download"
                    minimal={true}
                    large={false}
                    disabled={!canDownloadPart(part) || downloadingPartIds.includes(part.id)}
                    onClick={() => onDownloadPart(part)}
                />
            </div>
        ];
    });

    return (
        <Modal
            isOpen={showModal}
            onClose={onCloseModal}
            clickOutsideClose={true}
            title={title}
            size={ModalSize.MEDIUM}
            updateStateOnClose={false}
            footer={(
                <div className="bp6-dialog-footer-actions">
                    <Button
                        id="file-extract-parts-close"
                        text="Close"
                        intent="secondary"
                        onClick={onCloseModal}
                    />
                </div>
            )}
        >
            <ListingTable
                id="file-extract-parts-table"
                headers={partHeaders}
                data={partRows}
                columnWidths={partColumnWidths}
                totalRecordCount={parts.length}
                loadingData={false}
                pageable={false}
                showPerPage={false}
                rowClickEnabled={false}
                noDataHeading="No parts"
                noDataMessage="This extract has no parts to download."
            />
        </Modal>
    );
}

FileExtractPartsModal.propTypes = {
    showModal: PropTypes.bool,
    title: PropTypes.string,
    parts: PropTypes.array,
    downloadingPartIds: PropTypes.array,
    canDownloadPart: PropTypes.func.isRequired,
    getStatusDisplay: PropTypes.func.isRequired,
    onDownloadPart: PropTypes.func.isRequired,
    onCloseModal: PropTypes.func.isRequired
};
